import React, { createContext, useState, useEffect, useCallback, useRef } from "react";
import Cookies from "js-cookie";
import { generateAuthToken } from "../utils/common";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null)
  const isExtending = useRef(false)
  //const user = useRef()

  useEffect(() => {
    // const authToken = Cookies.get("authToken");
    const authToken = sessionStorage.getItem("authToken")
    const userDets = Cookies.get("userDets")
    if (authToken && userDets) {
      setIsAuthenticated(true);
      setUserRole(JSON.parse(userDets).role)
    } else {
      setIsAuthenticated(false);
    }
    setLoading(false);
  }, []);

  // useEffect(() => {
  //   const handleBeforeUnload = async () => {
  //     await logout();
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);



  const login = (newUser) => {
    const expiryTime = new Date(new Date().getTime() + 15 * 60 * 1000);
    const token = generateAuthToken();
    sessionStorage.setItem("authToken", token)
    // Cookies.set("authToken", token, { expires: expiryTime, secure: true, sameSite: "Strict" });
    Cookies.set("sessionExpiration", expiryTime.toISOString(), { expires: expiryTime, secure: true, sameSite: "Strict" });
    Cookies.set("userDets", JSON.stringify(newUser), { expires: expiryTime, secure: true, sameSite: "Strict" });
    setUser(newUser);
    setUserRole(newUser.role)
    //user.current = newUser

    setIsAuthenticated(true);
  };

  const logout = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/v1/dashboard/logout`;
      const res = await fetch(url, {
        headers: { "Content-Type": "application/json" },
        method: "POST",
        credentials: "include",
      });

      if (res.ok) {
        setIsAuthenticated(false);
        // Cookies.remove("authToken");
        sessionStorage.removeItem("authToken")

      }
    } catch (error) {
      console.error(error);
    }
  };

  const extendSession = useCallback(async () => {
    if (isAuthenticated && isExtending.current === false) {
      isExtending.current = true
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/v1/dashboard/extendSession`, {
          method: "POST",
          credentials: "include",
        });

        if (res.ok) {
          const newExpiryTime = new Date(new Date().getTime() + 15 * 60 * 1000);
          // Cookies.set("authToken", Cookies.get("authToken"), { expires: newExpiryTime, secure: true, sameSite: "Strict" });
          Cookies.set("sessionExpiration", newExpiryTime.toISOString(), { expires: newExpiryTime, secure: true, sameSite: "Strict" });
          Cookies.set("userDets", Cookies.get("userDets"), { expires: newExpiryTime, secure: true, sameSite: "Strict" });
          // slsetUserRole(newUser.role)
        } else {
          console.error("Failed to extend session");
        }
        isExtending.current = false
      } catch (error) {
        console.error("Error extending session:", error);
        isExtending.current = false
      }
    }
  }, [isAuthenticated, isExtending]);

  // useEffect(() => {
  //   let lastActivity = Date.now();
  //   let interval;

  //   const updateActivity = () => {
  //     lastActivity = Date.now();
  //   };

  //   window.addEventListener("mousemove", updateActivity);
  //   window.addEventListener("keydown", updateActivity);
  //   window.addEventListener("click", updateActivity);

  //   const checkActivity = () => {
  //     const sessionExpiry = new Date(Cookies.get("sessionExpiration")).getTime();
  //     if (sessionExpiry - lastActivity < 3 * 60 * 1000) {
  //       extendSession();
  //     }
  //   };

  //   interval = setInterval(() => {
  //     checkActivity();
  //   }, 1 * 60 * 1000);

  //   return () => {
  //     clearInterval(interval);
  //     window.removeEventListener("mousemove", updateActivity);
  //     window.removeEventListener("keydown", updateActivity);
  //     window.removeEventListener("click", updateActivity);
  //   };
  // }, [extendSession]);


  useEffect(() => {
    const extendIfNeeded = () => {
      const now = Date.now();
      const sessionExpiry = new Date(Cookies.get("sessionExpiration")).getTime();

      // If session will expire within 5 mins, extend it
      if (sessionExpiry - now < 5 * 60 * 1000) {
        extendSession();
      }
    };

    const handleActivity = () => {
      extendIfNeeded();
    };

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("click", handleActivity);

    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("click", handleActivity);
    };
  }, [extendSession]);




  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, user, userRole }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
